import { render } from "./WhatsAppCloud.vue?vue&type=template&id=3830feab"
import script from "./WhatsAppCloud.vue?vue&type=script&lang=js"
export * from "./WhatsAppCloud.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__